import { FundCalendar } from "@/types";

export interface FundCalendarsListControllerProps {
  calendars: FundCalendar[];
  selectedCalendar: FundCalendar | null;
  onSelect: (calendar: FundCalendar) => void;
  isLoading: boolean;
}

export const useFundCalendarsListController = (
  props: FundCalendarsListControllerProps
) => {
  const { calendars, selectedCalendar, onSelect, isLoading } = props;

  const handleSelect = (calendar: FundCalendar) => {
    onSelect(calendar);
  };

  return {
    calendars,
    selectedCalendar,
    isLoading,
    handleSelect,
  };
};
